
define('text!common/durandal/widgets/commonClock/view.html',[],function () { return '<time class="clock" data-bind="css: {\'is-showing-hour\': isShowingHour}">\n    <div class="numbers-container">\n        {{#foreach: { data: formattedTime, as: \'char\' }}}\n            <span data-bind="text:char" class="number-box"></span>\n        {{/foreach}}\n    </div>\n</time>\n';});

